<template src="./Contracts.html"></template>
<script>
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      idCompany: null,
      idDoctor: null,
      popupContract: false,
      contract: {},
      taxType: false,
      softwareTaxType: null,
      invalidFields: {
        name: false,
        consultTaxSoftware: false,
        consultTaxNurse: false,
        taxClinicPercentage: false,
        taxCancelationPercentage: false,
      },
      doctorName: "",
      myContracts: [],
      name: "",
      consultTaxSoftware: "",
      consultTaxNurse: "",
      taxClinicPercentage: "",
      taxCancelationPercentage: "",
      billed: "",
      issueRPS: false,
      fillMedicalRecordRequired: false,
      chargeWithdrawalFee: false,
      accredited: false,
      active: false,
      titlePopContract: "",
      showContract: false,
      contracts: [],
      taxOptions: [
        { text: "$", value: false},
        { text: "%", value: true},
      ],
    };
  },
  watch: {
    name: function(newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal)){
        vm.invalidFields.name = false;
      }
    },
    consultTaxNurse: function(newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal)){
        vm.invalidFields.consultTaxNurse = false;
      }
    },
    consultTaxSoftware: function(newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal)){
        vm.invalidFields.consultTaxSoftware = false;
      }
    },
    taxClinicPercentage: function(newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal)){
        vm.invalidFields.taxClinicPercentage = false;
      }
    },
    taxCancelationPercentage: function(newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal)){
        vm.invalidFields.taxCancelationPercentage = false;
      }
    },
  },
  mounted: function () {
    const vm = this;
    if (vm.testNullUndefinedEmpty(vm.$route.params.id) === false) {      
      vm.doctorName = vm.$route.params.name.toUpperCase();
      vm.init();
    }
  },
  methods: {
    init() {
      const vm = this;
      if (vm.$route.params.id) {
        // vm.idCompany = 2;
        vm.idDoctor = vm.$route.params.id;

      vm.getContracts();
      }
    },
    editContract(contractId) {
      const vm = this;
      vm.titlePopContract = "Editar contrato";
      vm.getContract(contractId);
    },
    addNewContract() {
      const vm = this;
      vm.contractId = null;
      vm.titlePopContract = "Novo contrato";
      vm.name = "";
      vm.consultTaxSoftware = "";
      vm.consultTaxNurse = "";
      vm.taxClinicPercentage = "";
      vm.taxCancelationPercentage = "";
      vm.billed = "";
      vm.issueRPS = false;
      vm.fillMedicalRecordRequired = true;
      vm.chargeWithdrawalFee = true;
      vm.accredited = false;
      vm.active = false;
      vm.contract = {};
      vm.popupContract = true;
      vm.softwareTaxType = 0;
      vm.taxType= false;
    },
    getContracts() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "contract/doctor-contracts/" + vm.idDoctor, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.myContracts = response.data;
          }
        });
    },
    getContract(contractId) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer + "contract/find_by_id/" + contractId,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.contract = response.data;
            vm.fillContract();
          }
        });
    },
    fillContract() {
      const vm = this;
      if (vm.testNullUndefinedEmpty(vm.contract.consultTaxNurse) === false) {
        let floatValue = parseFloat(vm.contract.consultTaxNurse);
        let fixedValue = floatValue.toFixed(2);
        vm.consultTaxNurse = fixedValue.toString().replace(".", ",");
      }
      if (vm.testNullUndefinedEmpty(vm.contract.consultTaxSoftware) === false) {
        if(vm.contract.softwareTaxType == 0){
        vm.taxType = false;
        let floatValue = parseFloat(vm.contract.consultTaxSoftware);
        let fixedValue = floatValue.toFixed(2);
        vm.consultTaxSoftware = fixedValue.toString().replace(".", ",");
        }else{
          vm.taxType = true;
           let floatValue = parseFloat(vm.contract.consultTaxSoftware);
        let fixedValue = floatValue.toFixed(2);
          vm.consultTaxSoftware = fixedValue.toString().replace(".", ",") + "%";
        }
      }
      if (
        vm.testNullUndefinedEmpty(vm.contract.taxCancelationPercentage) ===
        false
      ) {
        let floatValue = parseFloat(vm.contract.taxCancelationPercentage);
        let fixedValue = floatValue.toFixed(2);
        vm.taxCancelationPercentage = fixedValue.toString().replace(".", ",");
      }
      if (
        vm.testNullUndefinedEmpty(vm.contract.taxClinicPercentage) === false
      ) {
        let floatValue = parseFloat(vm.contract.taxClinicPercentage);
        let fixedValue = floatValue.toFixed(2);
        vm.taxClinicPercentage = fixedValue.toString().replace(".", ",");
      }
      vm.issueRPS = vm.contract.billed === true ? false : true;
      vm.active = vm.contract.active;
      vm.name = vm.contract.name;
      vm.fillMedicalRecordRequired =  vm.contract.notFillMedicalRecord === true? false : true;
      vm.chargeWithdrawalFee =  vm.contract.notChargeWithdrawalFee === true? false : true;
      vm.accredited = vm.contract.accredited;
      vm.popupContract = true;
    },
    validateFields() {
      const vm = this;
      let valid = true;
      if (vm.testNullUndefinedEmpty(vm.name)) {
        valid = false;
        vm.invalidFields.name = true;
      }
      if (vm.testNullUndefinedEmpty(vm.consultTaxNurse)) {
        valid = false;
        vm.invalidFields.consultTaxNurse = true;
      }
      if (vm.testNullUndefinedEmpty(vm.consultTaxSoftware)) {
        valid = false;
        vm.invalidFields.consultTaxSoftware = true;
      }
      if (vm.testNullUndefinedEmpty(vm.taxCancelationPercentage)) {
        valid = false;
        vm.invalidFields.taxCancelationPercentage = true;
      }
      if (vm.testNullUndefinedEmpty(vm.taxClinicPercentage)) {
        valid = false;
        vm.invalidFields.taxClinicPercentage = true;
      }
      if (valid === false) {
        vm.$vs.notify({
              title: "Atenção!",
              text: "Campos obrigatórios não preenchidos ou inválidos!",
              color: "warning",
              icon: "error_outline",
              position: "top-right",
            });
      } else {
        if (vm.testNullUndefinedEmpty(vm.contract.id)) {
          vm.saveNewContract();
        } else {
          vm.updateContract();
        }
      }
    },
    saveNewContract() {
      const vm = this;
      let contract = {
        name: vm.name,
        consultTaxNurse: vm.consultTaxNurse.toString().replace(",", "."),
        softwareTaxType: vm.taxType,
        consultTaxSoftware: vm.consultTaxSoftware.toString().replace(",", ".").replace("%" ,""),
        taxCancelationPercentage: vm.taxCancelationPercentage
          .toString()
          .replace(",", "."),
        taxClinicPercentage: vm.taxClinicPercentage.replace(",", "."),
        active: vm.active,
        notFillMedicalRecord: vm.fillMedicalRecordRequired == true ? false : true,
        notChargeWithdrawalFee: vm.chargeWithdrawalFee == true ? false : true,
        accredited: vm.accredited
      };
      contract.billed = vm.issueRPS === true ? false : true;

      vm.axios
        .post(vm.$store.state.filooServer + "contract/add-contract-doctor/" + vm.idDoctor , contract, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupContract = false;
            vm.$swal("Operação realizada", "O contrato <b style='color: #FF9F43; font-weight: 500'>" + contract.name + "</b> foi criado com sucesso!" , "success");
            vm.getContracts();
          }
        })
        .catch(function () {
          vm.popupContract = false;
          vm.$swal("Atenção!", "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema", "error");
        });
    },
    updateContract() {
      const vm = this;
      let contract = {
        id: vm.contract.id,
        name: vm.name,
        consultTaxNurse: vm.consultTaxNurse.toString().replace(",", "."),
        softwareTaxType: vm.taxType ,
        consultTaxSoftware: vm.consultTaxSoftware.toString().replace("," , "." ).replace("%" ,""),
        taxCancelationPercentage: vm.taxCancelationPercentage
          .toString()
          .replace(",", "."),
        taxClinicPercentage: vm.taxClinicPercentage.replace(",", "."),
        active: vm.active,
        notFillMedicalRecord: vm.fillMedicalRecordRequired == true ? false : true,
        notChargeWithdrawalFee: vm.chargeWithdrawalFee == true ? false : true,
        accredited: vm.accredited
      };
      contract.billed = vm.issueRPS === true ? false : true;
      vm.axios
        .put(vm.$store.state.filooServer + "contract/", contract, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupContract = false;
            vm.$swal("Operação realizada!", "Os dados do contrato <b style='color: #FF9F43; font-weight: 500'>" + contract.name + "</b> foram alterados com sucesso!", "success");
            vm.getContracts();
          }
        })
        .catch(function () {
          vm.popupContract = false;
          vm.$swal("Atenção!", "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema", "error");
        });
    },
  },
};
</script>

<style lang="scss" src="./Contracts.scss">
</style>
